import {createAction} from '@reduxjs/toolkit';

export const clearContracts = createAction('CLEAR_CONTRACTS');
